<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAirplaneLanding } from "@mdi/js"

export default {
  name: "AirplaneLandingIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiAirplaneLanding,
    }
  }
}
</script>
